'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgAndroid = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "100%", height: "100%", viewBox: "0 0 16 18", fill: "currentColor" }, props),
    React__default['default'].createElement("g", { fillRule: "evenodd" },
        React__default['default'].createElement("path", { d: "M11.812 11.335l-2.56-2.531v-.18l2.56-2.53.058.033 3.033 1.703c.866.486.866 1.282 0 1.77l-3.033 1.702-.058.033zM.287 1.078C.107 1.267 0 1.56 0 1.94v13.55c0 .38.107.672.287.86l.046.045 7.68-7.59v-.18l-7.68-7.59-.046.044zM11.25 11.915L8.632 9.327.907 16.963c.285.298.757.335 1.288.037l9.055-5.085M11.25 5.514L2.195.428C1.664.13 1.192.167.907.466L8.632 8.1l2.618-2.587z" })))); };

exports.default = SvgAndroid;
//# sourceMappingURL=index.js.map
